<template>
  <section class="gradient-ct-a-module-component">
    <div class="container">
      <BlurBG
        :blob-size="0.8"
        theme="dark">
        <template #default>
          <div class="inner-content">
            <h2 v-html="props.data.gradient_cta_title"></h2>

            <div class="mx-auto w-fit">
              <ArrowCircleButton
                v-if="data.gradient_cta_content"
                :link="data.gradient_cta_content"
                color="white" />
            </div>
          </div>
        </template>
      </BlurBG>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "GradientCTAComponent",
  "CLASSNAME": "gradient-ct-a-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import ArrowCircleButton from '@/components/utility/ArrowCircleButton.vue'
import BlurBG from '../utility/BlurBG.vue'

const props = defineProps(['data'])
</script>

<style lang="scss">
.gradient-ct-a-module-component {
  .container {
    @apply px-4 py-10 lg:px-11;

    .inner-content {
      @apply px-5 py-10 text-center lg:py-14;

      h2 {
        @apply quote mb-8 text-white;
      }
    }
  }
}
</style>
